import { attrSliceActions } from './attrSlice';

export const attrActions = {
  ...attrSliceActions,
};
